import { Grid } from '@mui/material';

import { FormAutocompleteField, FormDateField } from '../../../../../common';
import { disabledFutureDate } from '../../../../../../helpers';
import CrisisPlanRichTextField from './CrisisPlanRichTextField';
import { CRISIS_PLAN_FUNCTIONAL_BEHAVIOR_OPTIONS } from '../constants';
import { MONTH_YEAR_DISPLAY_FORMAT } from '../../../../../../constants';

import type { CrisisPlanFieldsProps } from './types';

export default function CrisisPlanFields({
  formik,
  disabled,
  readOnly,
  saveField,
  backgroundColor,
  relatedBehaviorOptions,
  relatedBehaviorRequired,
}: CrisisPlanFieldsProps) {
  const richTextProps = { disabled, formik, readOnly, saveField };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={6}>
        <FormAutocompleteField
          disabled={disabled}
          formik={formik}
          label="Related behavior"
          name="assessment_behavior_id"
          onChange={saveField}
          options={relatedBehaviorOptions}
          placeholder="Select related behavior"
          readOnly={readOnly}
          required={relatedBehaviorRequired}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6}>
        <FormDateField
          backgroundColor={backgroundColor}
          disabled={disabled}
          disabledDate={disabledFutureDate}
          formik={formik}
          format={MONTH_YEAR_DISPLAY_FORMAT}
          label="Crisis creation date"
          name="crisis_creation_date"
          onChange={saveField}
          picker="month"
          placeholder={MONTH_YEAR_DISPLAY_FORMAT}
          readOnly={readOnly}
          required
        />
      </Grid>
      <CrisisPlanRichTextField
        {...richTextProps}
        label="Operational definition"
        name="operational_definition"
      />
      <CrisisPlanRichTextField
        {...richTextProps}
        label="Antecedent interventions/modifications"
        name="antecedent_interventions"
      />
      <CrisisPlanRichTextField
        {...richTextProps}
        label="Precursors with action steps to prevent behavior"
        name="precursors_action_steps"
      />
      <CrisisPlanRichTextField
        {...richTextProps}
        label="Behavior intervention plan when escalation occurs"
        name="escalation_intervention_plan"
      />
      <CrisisPlanRichTextField {...richTextProps} label="Follow-up steps" name="follow_up_steps" />
      <Grid item xs={12}>
        <FormAutocompleteField
          disabled={disabled}
          formik={formik}
          label="Functional behavior"
          name="functional_behavior"
          onChange={saveField}
          options={CRISIS_PLAN_FUNCTIONAL_BEHAVIOR_OPTIONS}
          placeholder="Select functional behavior"
          readOnly={readOnly}
          required
        />
      </Grid>
      <CrisisPlanRichTextField
        {...richTextProps}
        label="Consequence strategies for behavior prior to escalation"
        name="consequence_strategies"
      />
    </Grid>
  );
}
